import { useCallback } from "react";

export function useIsoDateMask(onValue: (value: string) => void) {
  const formatIsoDateMask = useCallback((raw: string) => {
    const digits = raw.replace(/\D/g, "").slice(0, 8);
    const y = digits.slice(0, 4);
    const m = digits.slice(4, 6);
    const d = digits.slice(6, 8);

    let formatted = y;
    if (digits.length > 4) formatted += "-" + m;
    if (digits.length > 6) formatted += "-" + d;

    let caret = digits.length;
    if (digits.length > 4) caret += 1;
    if (digits.length > 6) caret += 1;

    return { formatted, caret };
  }, []);

  const handleIsoDateInput: React.FormEventHandler<HTMLInputElement> = useCallback((e) => {
    const input = e.currentTarget;
    const { formatted, caret } = formatIsoDateMask(input.value);
    input.value = formatted;
    onValue(formatted);
    requestAnimationFrame(() => {
      input.setSelectionRange(caret, caret);
    });
  }, [formatIsoDateMask, onValue]);

  return { handleIsoDateInput, formatIsoDateMask };
}
